// import axios from 'axios'
import SortService from '@/services/sort.service'

export default {
    namespaced: true,
    state: {
        loadingLead: false,
        lead: {},
    },
    mutations: {
        SET_LOADING_LEAD(state, loading) {
            state.loadingLead = loading;
        },
        SET_LEAD(state, lead) {
            state.lead = lead;
        },
        "SOCKET_UPDATE_LEAD"(state, data) {
            state.lead = data.type_id === 2 ? SortService.sortLead(data) : SortService.sortHealthLead(data);
        },
    },
    getters: {
        lead: state => state.lead,
        loadingLead: state => state.loadingLead,
    },
    actions: {
        // loadLead({ commit }, phoneNumber) {
        //     commit("SET_LOADING_LEAD", true);
        //     axios.get("")
        //         .then(res => {
        //             console.log("loadLead -> res", res)
        //             commit("SET_LOADING_LEAD", false);

        //         })
        //         .catch(e => {
        //             console.log("loadLead -> e", e)
        //             commit("SET_LOADING_LEAD", false);

        //         })
        // }
    },
}

